// extracted by mini-css-extract-plugin
export var contentcontainer = "SectionWithList-module--contentcontainer--41d34";
export var sectioncontainer = "SectionWithList-module--sectioncontainer--45f07";
export var sectionwithlist = "SectionWithList-module--sectionwithlist--2a40b";
export var title = "SectionWithList-module--title--c9bb6";